import { useEffect, useState } from 'react';
import {
    isEditModeNavigationStarted,
    startEditModeNavigation,
    subscribeEditModeNavigation,
} from './start-edit-mode-navigation';

/**
 * Tracks the in-page edit-mode navigation lock so the pencil can show a spinner
 * and ignore further clicks, including when edit mode is started with the `e` key.
 */
export function useEditModeNavigation(editLink: string) {
    const [isNavigating, setIsNavigating] = useState(() =>
        isEditModeNavigationStarted(),
    );

    useEffect(() => subscribeEditModeNavigation(setIsNavigating), []);

    return {
        isNavigating,
        start: () => startEditModeNavigation(editLink),
    };
}
